import React from 'react'
import NewHeader from '../Header/NewHeader'
import Footer from '../Footer'

function LandingVideo() {
    return (
        <div>
            <script type="application/ld+json">
                {JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "ItemList",
                    "itemListElement": [
                        {
                            "@type": "VideoObject",
                            "name": "How to create a project",
                            "description": "Learn how to create a project from scratch.",
                            "thumbnailUrl": "https://img.youtube.com/vi/xtvhCKVyL44/hqdefault.jpg",
                            "uploadDate": "2025-04-23", // usa la fecha real de publicación si puedes
                            "embedUrl": "https://www.youtube.com/embed/xtvhCKVyL44",
                            "url": "https://www.youtube.com/watch?v=xtvhCKVyL44"
                        },
                        {
                            "@type": "VideoObject",
                            "name": "Edit, Remove & Download Your Framework",
                            "description": "Learn how to edit, remove and download your framework.",
                            "thumbnailUrl": "https://img.youtube.com/vi/OOG5vc3Z5Yo /hqdefault.jpg",
                            "uploadDate": "2025-04-23",
                            "embedUrl": "https://www.youtube.com/embed/OOG5vc3Z5Yo",
                            "url": "https://www.youtube.com/watch?v=OOG5vc3Z5Yo"
                        },
                        {
                            "@type": "VideoObject",
                            "name": "Build Your Project Framework",
                            "description": "Step-by-step guide to building your project framework.",
                            "thumbnailUrl": "https://img.youtube.com/vi/nQzy2pk_Zf8/hqdefault.jpg",
                            "uploadDate": "2025-04-23",
                            "embedUrl": "https://www.youtube.com/embed/nQzy2pk_Zf8",
                            "url": "https://www.youtube.com/watch?v=nQzy2pk_Zf8"
                        },
                        {
                            "@type": "VideoObject",
                            "name": "Create WBS",
                            "description": "Learn how to create a work breakdown structure.",
                            "thumbnailUrl": "https://img.youtube.com/vi/zwhkgZxkBXY/hqdefault.jpg",
                            "uploadDate": "2025-04-23",
                            "embedUrl": "https://www.youtube.com/embed/zwhkgZxkBXY",
                            "url": "https://www.youtube.com/watch?v=zwhkgZxkBXY"
                        }
                    ]
                })}
            </script>

            <NewHeader />
            <header className="bg-light text-dark text-center py-5">
                <h1>How-To Videos</h1>
                <p className="lead">Learn with our step-by-step videos.</p>
            </header>

            <main className="container my-5">
                <div className="row">


                    <div className="col-md-3 mb-4 d-flex">
                        <div className="card h-100 w-100">
                            <a href="https://www.youtube.com/watch?v=xtvhCKVyL44" target="_blank">
                                <img src="https://img.youtube.com/vi/xtvhCKVyL44/hqdefault.jpg" className="card-img-top video-thumbnail" alt="Video 1" />
                            </a>
                            <div className="card-body">
                                <h5 className="card-title"> How to create a project </h5>
                                {/* <p className="card-text">Una guía rápida sobre cómo hacer X fácilmente.</p> */}
                            </div>
                        </div>
                    </div>


                    <div className="col-md-3 mb-4 d-flex">
                        <div className="card h-100 w-100">
                            <a href="https://www.youtube.com/watch?v=OOG5vc3Z5Yo" target="_blank">
                                <img src="https://img.youtube.com/vi/OOG5vc3Z5Yo/hqdefault.jpg" className="card-img-top video-thumbnail" alt="Video 2" />
                            </a>
                            <div className="card-body">
                                <h5 className="card-title">Edit, Remove & Download Your Framework
                                </h5>
                                {/* <p className="card-text">Aprende a resolver Y paso a paso.</p> */}
                            </div>
                        </div>
                    </div>


                    <div className="col-md-3 mb-4 d-flex">
                        <div className="card h-100 w-100">
                            <a href="https://www.youtube.com/watch?v=nQzy2pk_Zf8" target="_blank">
                                <img src="https://img.youtube.com/vi/nQzy2pk_Zf8/hqdefault.jpg" className="card-img-top video-thumbnail" alt="Video 3" />
                            </a>
                            <div className="card-body">
                                <h5 className="card-title"> Build Your Project Framework</h5>
                                {/* <p className="card-text">Descubre cómo se hace Z de manera sencilla.</p> */}
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3 mb-4 d-flex">
                        <div className="card h-100 w-100">
                            <a href="https://www.youtube.com/watch?v=zwhkgZxkBXY" target="_blank">
                                <img src="https://img.youtube.com/vi/zwhkgZxkBXY/hqdefault.jpg" className="card-img-top video-thumbnail" alt="Video 4" />
                            </a>
                            <div className="card-body">
                                <h5 className="card-title">Create WBS</h5>
                                {/* <p className="card-text">Descubre cómo se hace Z de manera sencilla.</p> */}
                            </div>
                        </div>
                    </div>

                </div>
            </main>

            <Footer />
        </div>
    )
}

export default LandingVideo